import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { push } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const addLastPathParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.addLastPathParam),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { locationState, segment } = payload;

    const location = locationSelector(state);
    const pathname = location.pathname.replace(/\/$/, '');

    // Encode segment to handle special characters like # in symbol names
    const encodedSegment = encodeURIComponent(segment);

    return [
      push({
        ...location,
        pathname: `${pathname}/${encodedSegment}`,
      }, locationState),
    ];
  }),
);
